<template>
  <footer class="te-footer bg-co-gray-700">
    <div class="co-container-lg px-4 py-5">
      <slot name="top-menu" />

      <div class="flex flex-col gap-4 text-[0.75rem] md:flex-row">
        <ul class="mr-auto flex flex-wrap gap-x-6 gap-y-2">
          <li>
            <a
              href="https://www.3sss.co.jp/about/index.html"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
              target="_blank"
            >
              運営会社：株式会社システムシェアード
            </a>
          </li>
          <li>
            <a
              href="/biz/terms"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              利用規約
            </a>
          </li>
          <li>
            <a
              href="https://www.3sss.co.jp/privacy-policy/"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
              target="_blank"
            >
              個人情報保護基本方針
            </a>
          </li>
        </ul>
      </div>

      <div class="text-center text-co-gray-500">
        <small class="text-[0.875em]">&copy;&nbsp;{{ currentYear }}&nbsp;System Shared Inc. All Rights Reserved.</small>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useDateFormat, useNow } from '@vueuse/core'

const currentYear = useDateFormat(useNow(), 'YYYY')
</script>
